import { c as _c } from "react/compiler-runtime";
import { BottomSheetBody, BottomSheetFooter, BottomSheetHeader, BottomSheetHeaderTitle, EmptyState } from "@opensea/ui-kit";
import { useMountEffect } from "@opensea/ui-kit/hooks";
import { useTranslations } from "use-intl";
import { useTrackEvent } from "../../providers/TrackEventProvider";
import { FlowActions, FlowState } from "../../stores/flowStore";
import { Button } from "../Button";
import { MAX_PRICE_CHANGE_PERCENTAGE } from "./constants";
export function PriceChangeError(t0) {
  const $ = _c(22);
  const {
    priceValidation
  } = t0;
  const t = useTranslations("wallet.PriceChangeError");
  const trackEvent = useTrackEvent();
  let t1;
  if ($[0] !== priceValidation || $[1] !== trackEvent) {
    t1 = () => {
      trackEvent("Price Changed Error Shown", {
        flow: FlowState.flow?.type,
        priceValidation
      });
    };
    $[0] = priceValidation;
    $[1] = trackEvent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useMountEffect(t1);
  let t2;
  if ($[3] !== t) {
    t2 = t("title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <BottomSheetHeader><BottomSheetHeaderTitle hidden={true}>{t2}</BottomSheetHeaderTitle></BottomSheetHeader>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("description", {
      percentage: MAX_PRICE_CHANGE_PERCENTAGE
    });
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("title");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <BottomSheetBody><EmptyState description={t4} title={t5} variant="no-results" /></BottomSheetBody>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("close");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <BottomSheetFooter className="items-center"><Button className="w-fit" onClick={FlowActions.endFlow} variant="secondary">{t7}</Button></BottomSheetFooter>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t3 || $[19] !== t6 || $[20] !== t8) {
    t9 = <>{t3}{t6}{t8}</>;
    $[18] = t3;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}